import { FiCheckCircle, FiCircle } from "react-icons/fi";

export default function MappingReadiness({
  employee,
  machineId,
  startDate,
  reason,
  verified,
  deviceActive,
}) {
  const steps = [
    { label: "Select an employee from the search results", done: !!employee },
    { label: "Enter the exact machine user ID", done: !!machineId.trim() },
    { label: "Choose the first valid date", done: !!startDate },
    {
      label: "Add a review reason (at least 10 characters)",
      done: reason.trim().length >= 10,
    },
    { label: "Confirm the identity and date check", done: verified },
  ];
  const completed = steps.filter((s) => s.done).length;
  return (
    <div
      id="mapping-readiness"
      className="mt-5 rounded-xl border border-slate-200 bg-slate-50 p-4"
      aria-live="polite"
    >
      <div className="flex items-center justify-between gap-3">
        <p className="text-sm font-semibold text-slate-900">
          {completed === 5 && deviceActive
            ? "Ready to link"
            : "Before you link"}
        </p>
        <span className="text-xs text-slate-500">
          {completed} of 5 complete
        </span>
      </div>
      <ul className="mt-3 space-y-2">
        {steps.map((step) => (
          <li
            key={step.label}
            className={`flex items-start gap-2 text-xs leading-5 ${step.done ? "text-green-800" : "text-slate-600"}`}
          >
            {step.done ? (
              <FiCheckCircle aria-label="Complete" className="mt-1 shrink-0" />
            ) : (
              <FiCircle aria-label="Required" className="mt-1 shrink-0" />
            )}
            <span>{step.label}</span>
          </li>
        ))}
      </ul>
      {!deviceActive && (
        <p className="mt-3 text-sm font-medium text-red-700">
          This device is inactive. Activate it before linking an employee.
        </p>
      )}
      {completed < 5 && (
        <p className="mt-3 border-t border-slate-200 pt-3 text-xs text-slate-600">
          Complete the remaining steps to enable Link Employee.
        </p>
      )}
    </div>
  );
}
